import Api from '../../../shared/Api';
import { TranslationDto, UpdateTranslationInput } from '../types';

const baseUrl = '/views/translations';

function urlFor(key: string): string {
    return `${baseUrl}/${key.split('/').map(encodeURIComponent).join('/')}`;
}

const TranslationsApi = {
    get(key: string): Promise<TranslationDto> {
        return new Api().get(urlFor(key));
    },

    update(key: string, input: UpdateTranslationInput): Promise<TranslationDto> {
        return new Api().put(urlFor(key), input);
    }
};

export default TranslationsApi;
